angular.module('impactx.search').controller('SearchInputCtrl', [
    '$scope',
    '$controller',
    'searchFilter',
    '$workspace',
    '$mdDialog',
    'TranslationService',
    '$location',
    'SearchSuggestions',
    '$context',
    'SearchService',
    'SearchFilter',
    'SearchFilterStorage',
    '$redirect',
    'BackService',
    '$route',
    '$securityManager',
    '$timeout',
    'AppConfiguration',
    SearchInputCtrl]);

function SearchInputCtrl($scope, $controller, searchFilter, $workspace, $mdDialog, TranslationService, $location,
                         SearchSuggestions, $context, SearchService, SearchFilter, SearchFilterStorage, $redirect,
                         BackService, $route, $securityManager, $timeout, AppConfiguration) {
    angular.extend(this, $controller('SearchCtrl', {$scope: $scope}));
    var ctrl = this;
    var hasTemporaryClassification = false;
    var allClassificationsEntry = {id: 0};
    var searchEnabled = false;
    var categorySelectAttrWatcher;
    var minSuggestSize = AppConfiguration.get('minSuggestSize');

    ctrl.showGuidingClassificationFilter = false;
    ctrl.listSearch = searchFilter.listSearch;
    ctrl.onDetailSearchRoute = false;
    ctrl.globalSearchFocused = false;

    var trnsWatcher = $scope.$watch(function () {
        return TranslationService.isInitialized();
    }, function (newVal) {
        if (newVal) {
            ctrl.trns = {
                termLabel: TranslationService.get('termSuggestions'),
                searchHistoryLabel: TranslationService.get('searchHistorySuggestions'),
                classificationLabel: TranslationService.get('classificationSuggestions'),
                supplierLabel: TranslationService.get('supplierSuggestions'),
                allCategories: TranslationService.get('allCategories'),
                showAll: TranslationService.get('showAll'),
                lotLabel: TranslationService.get('lotSuggestions'),
                searchPlain: TranslationService.get('searchPlain'),
                searchPlainLocal: TranslationService.get('searchPlainLocal'),
            };
            $scope.searchAllTranslation = TranslationService.get('searchAll');
            $scope.searchProductsTranslation = TranslationService.get('searchProducts');

            if (ctrl.showGuidingClassificationFilter && $securityManager.isProcessAllowed("Search")) {
                ctrl.loadGuidingClassifications().then(function () {
                    ctrl.selectedGuidingClassification = allClassificationsEntry;
                    $scope.transferGuidingClassification = allClassificationsEntry;
                });
            }
            $scope.transferSupplier = null;
            allClassificationsEntry = {id: 0, value: ctrl.trns.allCategories};
            trnsWatcher();
        }
    });

    function removeTemporaryClassificationEntry() {
        if (hasTemporaryClassification) {
            ctrl.guidingClassifications.shift();
            hasTemporaryClassification = false;
        }
    }

    ctrl.searchGlobal = function (item) {
        ctrl.search(item);
        ctrl.focused = false;
    }

    ctrl.searchLocal = function (item) {
        ctrl.search(item);
        ctrl.focused = false;
    }

    $scope.$watch(function () {
        return TranslationService.get('searchPlaceHolder')
    }, function (newVal) {
        if (SearchFilterStorage.getSearchFilterPlaceHolder()) {
            $scope.searchPlaceHolder = SearchFilterStorage.getSearchFilterPlaceHolder()
        }
        else {
            $scope.searchPlaceHolder = newVal;
        }
    });

    if ($scope.global)
    {
        $scope.$watch(function () {
            return ctrl.focused
        }, function (newVal) {
            SearchService.setGlobalSearchFocused(newVal);
        });
    }

    if (!$scope.global)
    {
        $scope.$watch(function () {
            return SearchService.isGlobalSearchFocused()
        }, function (newVal) {
            ctrl.globalSearchFocused = newVal;
        });
    }

    $scope.$watch(function () {
        return SearchFilterStorage.getSearchFilterPlaceHolder()
    }, function (newVal) {
        if (newVal) {
            $scope.searchPlaceHolder = newVal;
            $scope.canResetSearchInput = SearchFilterStorage.getCanResetSearchInput();
        }
        else {
            $scope.searchPlaceHolder = TranslationService.get('searchPlaceHolder');
            $scope.canResetSearchInput = false;
        }
    });

    $scope.$watch(function () {
        return $context.hasActiveShopView.value
    }, function (newVal) {
        $scope.activeShopView = newVal;
    });

    if ($scope.global)
    {
        $scope.$on('$routeChangeStart', function (event, newRoute, oldRoute) {
            ctrl.onDetailSearchRoute = newRoute.originalPath.indexOf("/vcatalog/") === 0 ||
                newRoute.originalPath.indexOf("/lot/") === 0 ||
                newRoute.originalPath.indexOf("/manufacturer/") === 0 ||
                newRoute.originalPath.indexOf("/supplier/") === 0 ||
                newRoute.originalPath.indexOf("/tender/") === 0;
        });
    }

    ctrl.refreshSuggests = function (searchText) {
        return SearchSuggestions.getSuggestions(searchText, !$scope.global).then(function (result) {
            $scope.amountTermEntries = 0;
            $scope.amountSearchHistory = 0;
            $scope.amountClassification = 0;
            $scope.amountSupplier = 0;
            $scope.amountLot = 0;
            if (result) {
                angular.forEach(result, function (entry) {
                    if (entry.isTerm) {
                        $scope.amountTermEntries++;
                    }
                    else if (entry.isSearchHistory) {
                        $scope.amountSearchHistory++;
                    }
                    else if (entry.isClassification) {
                        $scope.amountClassification++;
                    }
                    else if (entry.isSupplier) {
                        $scope.amountSupplier++;
                    }
                    else if (entry.isLot) {
                        $scope.amountLot++;
                    }
                });
            }
            $timeout(function () {
                var outerContainer = document.querySelector('.md-autocomplete-suggestions-container');
                var innerContainer = document.querySelector('.md-virtual-repeat-sizer');
                if (outerContainer && innerContainer)
                {
                    outerContainer.style.height = innerContainer.style.height;
                }
            });
            return result;
        });
    };

    ctrl.show = function (ev) {
        $mdDialog.show({
            controller: "SearchDialogCtrl",
            templateUrl: './modules/search/templates/searchmenu.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            hasBackdrop: false,
            disableParentScroll: false
        });

    };

    ctrl.focusClickGlobal = function () {
        ctrl.focused = true;
        $timeout(function () {
            angular.element('#mainSearchAC input').focus();
        })
    };

    ctrl.focusClickLocal = function () {
        ctrl.focused = true;
        $timeout(function () {
            angular.element('#mainSearchLocalAC input').focus();
        })
    };

    ctrl.focus = function () {
        ctrl.focused = true;
    };

    ctrl.blur = function ($event) {
        const elem = document.querySelector(".ix-main-search-wrapper");
        if(elem === null || !elem.contains($event.relatedTarget))
        {
            ctrl.focused = false;
        }
    };

    ctrl.searchEnabled = function () {
        searchEnabled = $workspace.getCurrentWorkspaceId().value === 'shop';
        return searchEnabled;
    };

    $scope.deleteSearchInput = function () {
        searchFilter.searchInput = '';
        SearchFilter.resetSearchInput();
    };

    ctrl.setSelectedGuidingClassification = function (selectedClassification) {
        if (!angular.equals(selectedClassification, ctrl.guidingClassifications[0])) {
            removeTemporaryClassificationEntry();
        }
        $scope.transferGuidingClassification = selectedClassification;
    };

    if (ctrl.showGuidingClassificationFilter) {
        $scope.$watch(function () {
            return searchEnabled;
        }, function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                var categorySelectFinder = $scope.$watch(function () {
                    return angular.element('#categorySelect');
                }, function (categorySelect) {
                    if (categorySelect && categorySelect.length === 1) {
                        categorySelectAttrWatcher = $scope.$watch(function () {
                            return categorySelect.attr('aria-expanded');
                        }, function (newValue, oldValue) {
                            if (oldValue === 'true' && newValue === 'false') {
                                angular.element('#mainSearchAC').find('input').focus();
                            }
                        });
                        categorySelectFinder();
                    }
                });
            }
            else if (!newValue && newValue !== oldValue) {
                if (categorySelectAttrWatcher) {
                    categorySelectAttrWatcher();
                }
            }
        });
    }

    ctrl.loadGuidingClassifications = function () {
        return SearchFilter.getLevelOneGuidingClassification().then(function (classifications) {
            ctrl.guidingClassifications = classifications;
            ctrl.guidingClassifications.unshift(allClassificationsEntry);
        });
    }

    ctrl.inputSearch = function () {
        SearchFilter.setFilterIdentifier();
        ctrl.search();
    }

    ctrl.resetSearchInput = function () {
        SearchFilter.setFilterIdentifier();
        var currentRoute = $route.current.$$route.originalPath;
        if (currentRoute.indexOf("vcatalog/") >= 0 ||
            currentRoute.indexOf("tender/") >= 0 ||
            currentRoute.indexOf("lot/") >= 0 ||
            currentRoute.indexOf("supplier/") >= 0) {
            SearchFilterStorage.setGlobalFilter(SearchFilterStorage.getFreshFilter());
        }
        else {
            SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());
        }
        SearchFilter.setSearchInputClassification(null);
        searchFilter.searchInput = "";
        $redirect.redirectTo(null, "/search");

    }

    ctrl.isHighContrastActive = function() {
        return $workspace.getHighContrastActive();
    }

    ctrl.minSuggestSize = function() {
        return minSuggestSize;
    }
}
